<template>
    <div class="page-content">
        <tableau-viz v-if="selectedContent" :view="selectedContent" :key="selectedContent.id" @viewLoaded="onViewLoaded" />
    </div>
</template>
<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import TableauViz from '../TableauViz.vue'

    export default {
        name: 'DashboardView',
        components: {
            'tableau-viz': TableauViz
        },
        props: {
            viewName: {
                type: String
            }
        },
        watch: {
            'views': 'loadContent',
            'viewName': 'loadContent',
            // Duplicate-named views can share a urlName/route, so clicking between them doesn't
            // change the route (no 'viewName' change) - react to the click itself instead
            'clickedViewId': 'loadContent'
        },
        created() {
            this.loadContent()
        },
        computed: {
            ...mapGetters(['loadedViz', 'views', 'summaryView', 'selectedContent', 'clickedViewId'])
        },
        methods: {
            ...mapActions(['login', 'logEvent']),
            ...mapMutations(['SELECT_CONTENT']),
            async onViewLoaded() {
                await this.logEvent('View loaded')
            },
            loadContent() {
                let selected = null

                if (this.viewName) {
                    const matches = this.views.filter(v => v.urlName === this.viewName)

                    // Several views can share the same urlName; prefer the one that was actually clicked
                    selected = matches.find(v => v.id === this.clickedViewId) || matches[0]
                }
                else {
                    selected = this.summaryView
                }

                this.SELECT_CONTENT(selected)
            }
        }
    }
</script>
